import { render } from "./FrontUnitChooserOption.vue?vue&type=template&id=fffd2e6e&scoped=true"
import script from "./FrontUnitChooserOption.vue?vue&type=script&lang=js"
export * from "./FrontUnitChooserOption.vue?vue&type=script&lang=js"

import "./FrontUnitChooserOption.vue?vue&type=style&index=0&id=fffd2e6e&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffd2e6e"]])

export default __exports__